import React, { useState } from "react";
import { useFormikContext } from "formik";
import TextField from "@mui/material/TextField";

import TotalReceivingUnitsModal from "./TotalReceivingUnitsModal";
import getTotalReceivingUnitsLabel from "./getTotalReceivingUnitsLabel";
import { shipmentTypes } from "../../../../../constants/receiving-wizard";

export default function TotalReceivingUnits({ name, label }) {
  const [open, setOpen] = useState(false);
  const { values, setFieldValue } = useFormikContext();
  const { errors, submitCount, getFieldMeta } = useFormikContext();
  const meta = getFieldMeta(name);
  const errorMessage = meta.error || errors[name];
  const error = (meta.touched || submitCount > 0) && errorMessage;

  const handleToggle = () => {
    setOpen(v => !v);
  };

  const handleSave = list => {
    setFieldValue("totalPieces", list);
    handleToggle();
  };

  return (
    <>
      <TextField
        fullWidth
        error={!!error}
        helperText={error}
        size="small"
        label={label}
        value={getTotalReceivingUnitsLabel(
          Array.isArray(values.totalPieces) ? values.totalPieces : []
        )}
        onClick={handleToggle}
      />
      {open && (
        <TotalReceivingUnitsModal
          title="Total Handling Units"
          typeLabel="Unit Type"
          quantityLabel="# Received"
          addLabel="Add Another Unit"
          name="totalPieces"
          value={values.totalPieces}
          label="Total Handling Units"
          typeOptions={shipmentTypes}
          onSave={handleSave}
          onClose={handleToggle}
        />
      )}
    </>
  );
}
